import { ApplicationContext } from '@/context/ApplicationContext';
import { useContext } from 'react';

export const useApplication = () => useContext(ApplicationContext);
